import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import SidebarNavShell from '../SidebarNavigation/SidebarNavShell';

/**
 * Sidebar shown to logged-out visitors. Reuses the app's SidebarNavShell chrome
 * (logo + rail) so the guest view matches the authenticated sidebar, but the
 * body offers only the Create Account / Sign In links (which are Tornado routes,
 * hence plain anchors). The logo points at the public landing page.
 */
function GuestSidebar() {
  return (
    <SidebarNavShell logoTo="/">
      <nav className="side-nav-primary" aria-label={t`Account`}>
        <a href="/user/register" className="menu-item">
          <Trans>Create Account</Trans>
        </a>
        <a href="/user/login" className="menu-item">
          <Trans>Sign In</Trans>
        </a>
      </nav>
    </SidebarNavShell>
  );
}

export default GuestSidebar;
